import {inject} from '@angular/core';
import {RedirectFunction, Router, Routes} from '@angular/router';

export function shipmentDetailTab(value: string | null | undefined): string {
  return ({status: 'overview', shipper: 'parties', receiver: 'parties', commodities: 'cargo',
    overview: 'overview', parties: 'parties', docs: 'docs', quote: 'quote', cargo: 'cargo', timeline: 'timeline'})[value || ''] || 'overview';
}

const redirectShipmentDetail: RedirectFunction = ({params, queryParams}) => inject(Router).createUrlTree(
  ['/company-shipments/new'],
  {queryParams: {...queryParams, shipment: params['trackNumber'], tab: shipmentDetailTab(params['detailSection'])}}
);

/** Keep bookmarks, notifications, invoice and overview links working in the new workspace. */
export const CompanyShipmentDetailRedirects: Routes = [
  {path: 'company-shipment-detail/:trackNumber/:detailSection', pathMatch: 'full', redirectTo: redirectShipmentDetail},
  {path: 'company-shipment-detail/:trackNumber', pathMatch: 'full', redirectTo: redirectShipmentDetail}
];
